import React, { Component } from 'react'
import { Form, Select, DatePicker, Button } from 'antd'
import { withTranslation } from 'react-i18next'
import styled from 'styled-components'
import moment from 'moment'
import operatorAPI from '@/API/operator'
const { Option } = Select;

const FilterContainer=styled.div`
  padding:20px;
`

class Filter extends Component {
  constructor(props) {
    super(props);
    this.state = {
      productList:[],
      endDate:moment().subtract(1, 'days').startOf('day')
     }
  }
  componentDidMount() {    
    this.props.filterChange('endDate',this.state.endDate)
    this.getProductList()
  }
  getProductList(){
    operatorAPI.getProductList().then((res)=>{
      this.setState({productList:res})
    })
  }
  
  render() {
    const {productList,endDate}=this.state
    const {t,filterChange,search,exp} = this.props
    const disabledDate = (current) => {
      return current > moment().subtract(1, 'days').startOf('day')
    }
      
    return (
      <FilterContainer>
        <Form layout="inline">
          <Form.Item label={t("Model")}>
            <Select allowClear mode="multiple" maxlength="0" style={{width:350}} onChange={(value)=>{filterChange('productNameList',value)}}>
              {
                productList.map((product)=>
                  <Option value={product} key={product}>{product}</Option>
                )
              }
            </Select>
          </Form.Item>
          <Form.Item label={t("Deadline")}>
            <DatePicker allowClear onChange={(value)=>{filterChange('endDate',value)}} defaultValue={endDate} disabledDate={disabledDate}></DatePicker>
          </Form.Item>
          <Form.Item>
            <Button onClick={search}>{t('Search')}</Button>
          </Form.Item>
          <Form.Item>
            <Button onClick={exp}>{t('Export')}</Button>
          </Form.Item>
        </Form>
      </FilterContainer>
    )
  }
}

export default withTranslation()(Filter);